/**
 * Desinstala o que a versão com suporte offline deixou no navegador.
 *
 * Parar de registrar o service worker não basta: quem já o tem instalado
 * continuaria sendo servido pelo cache dele — inclusive o index.html —, e não
 * receberia mais nenhum deploy. Por isso, além de não registrar, é preciso
 * remover o registro existente e apagar os caches que ele criou.
 *
 * O IndexedDB também vai embora: guardava respostas da API e a fila de
 * escritas pendentes, e a fila carregava o header Authorization (o token).
 * Sem a sincronização, esses dados nunca mais seriam enviados nem lidos.
 *
 * Tudo aqui é best-effort e silencioso: é limpeza de fundo, não pode quebrar
 * o carregamento do app.
 */

const OFFLINE_DB_NAME = "sisagri-offline-db";

export function removeOfflineSupport() {
	if ("serviceWorker" in navigator) {
		navigator.serviceWorker
			.getRegistrations()
			.then((registrations) =>
				Promise.all(registrations.map((registration) => registration.unregister()))
			)
			.catch((error) =>
				console.warn("Não foi possível remover o service worker:", error)
			);
	}

	if (typeof caches !== "undefined") {
		caches
			.keys()
			.then((keys) => Promise.all(keys.map((key) => caches.delete(key))))
			.catch((error) =>
				console.warn("Não foi possível limpar os caches do app:", error)
			);
	}

	if (typeof indexedDB !== "undefined") {
		try {
			indexedDB.deleteDatabase(OFFLINE_DB_NAME);
		} catch (error) {
			console.warn("Não foi possível apagar o banco offline:", error);
		}
	}
}
